import React from 'react';

/**
 * PWA Detection Utilities
 * Provides functions to detect and handle Progressive Web App behavior
 */

/**
 * Detects if the app is running in PWA standalone mode
 * @returns {boolean} True if running as PWA
 */
export function isPWA() {
  // Check for standalone mode (modern PWA detection)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }

  // Check for iOS Safari standalone mode
  if (window.navigator.standalone === true) {
    return true;
  }

  // Check for query parameter (useful for testing)
  if (window.location.search.includes('standalone=true')) {
    return true;
  }

  return false;
}

/**
 * Hook to detect PWA mode with state management
 * @returns {boolean} True if running as PWA
 */
export function useIsPWA() {
  const [isPWAMode, setIsPWAMode] = React.useState(false);

  React.useEffect(() => {
    // Initial check
    setIsPWAMode(isPWA());

    // Listen for changes in display mode
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleChange = (e) => setIsPWAMode(e.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } else {
      // Fallback for older browsers
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, []);

  return isPWAMode;
}
